import { render, staticRenderFns } from "./KlfsFooter.vue?vue&type=template&id=821e4efa&scoped=true"
import script from "./KlfsFooter.vue?vue&type=script&lang=js"
export * from "./KlfsFooter.vue?vue&type=script&lang=js"
import style0 from "./KlfsFooter.vue?vue&type=style&index=0&id=821e4efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821e4efa",
  null
  
)

export default component.exports